import React, { useContext } from "react";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import moment from "moment";
import { CurrencyContext } from "../../context/Context";
import { useSelector } from "react-redux";

const PropertyDebtToPayRow = ({ debt }) => {
  const { currency: curr, loading, baseCurrency } = useContext(CurrencyContext);
  const { currency } = useSelector((state) => state.auth);

  return (
    <>
      <tr>
        <td>
          <Link
            to={{
              pathname: `/dashboard/my/finance/topay/${debt.id}`,
              state: {
                amount: debt.amount,
                date: debt.created_at,
                propertyDebtId: debt.id,
                aliquot: debt.aliquot,
                paymented: debt.paymented,
              },
            }}
          >
            {debt?.name != null && debt?.finance?.name
              ? debt?.name
                ? debt?.name
                : debt.finance.name
              : debt?.reserve_fund?.name}
          </Link>
        </td>
        <td>Cuenta por pagar del mes</td>
        <td className="text-center">
          <NumberFormat
            prefix={`${baseCurrency.symbol} `}
            thousandSeparator
            displayType="text"
            value={debt.amount.toFixed(2)}
          />
          <NumberFormat
            className="text-right"
            displayType="text"
            allowedDecimalSeparators={true}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale
            prefix={" | " + curr?.currency?.iso + " "}
            value={debt.amount_converted ?? Number(debt.amount || 0) * Number(curr?.value || 0)}
          />
        </td>
        <td className="text-right">
          {debt.expires_at
            ? moment(debt.expires_at).format("DD-MM-YYYY")
            : "Día de pago del condominio"}
        </td>
      </tr>
    </>
  );
};

export default PropertyDebtToPayRow;
